import { render, staticRenderFns } from "./subscriptions.vue?vue&type=template&id=4d9c374a"
import script from "./subscriptions.ts?vue&type=script&lang=js&external"
export * from "./subscriptions.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports